export class TopToolbarTextDataES {
    static readonly htmlLabel = {
        welcome: 'Bienvenido',
        orgAdmin: '(Administrador de la Organización)',
        deptAdmin: '(Administrador del Departamento)',
        licenseExpired: 'Tu licencia ha expirado. ¡Por favor, contacta al soporte!',
        toolBoxPrepTraining: 'Entrenamiento PREP',
        toolBoxQuickStartGuide: 'Guía de Inicio Rápido',
        notificationHeading: 'Notificaciones',
        notficationPart1Text: 'Tienes ',
        notificationPart2Text: ' nuevas notificaciones.',
        notificationFineText: '¡Todo bien! No hay notificaciones en este momento.',
        notificationMarkRead: 'Marcar todo como leído',
        resourceText: 'Recursos PREP',
        resourceTutorial: 'Entrenamiento PREP',
        resourceOnboardDoc: 'Guía de Inicio Rápido',
        resourceVideo: 'Videos PREP',
        resourceVideoSubmenuItem1: 'Comenzando con la Herramienta PREP',
        resourceVideoSubmenuItem2: 'Uso del Editor de Etiquetas de Remediación',
        resourceVideoSubmenuItem3: 'Comprendiendo los Tipos de Etiquetado',
        resourceVideoSubmenuItem4: 'Información General y Directrices',
        resourceVideoSubmenuItem5: 'Configuración de la Cuenta PREP',
        userProfileText: 'Perfil',
        userProfileLogoutText: 'Cerrar sesión',
    };
    static readonly snackbarLabel = {

    };
    static readonly tooltipLabel = {
        toolBoxNotification: 'NOTIFICACIÓN',
        resourceMenu: 'Menú de Recursos PREP',
        toolBoxPrepTraining: 'ENTRENAMIENTO PREP',
        toolBoxHelp: 'AYUDA',
        toolBoxExitFullScreen: 'SALIR DEL MODO DE PANTALLA COMPLETA',
        toolBoxEnterFullScreen: 'ENTRAR EN EL MODO DE PANTALLA COMPLETA',
        toolBoxReleaseNotes: 'NOTAS DE LA VERSIÓN',
        toolBoxUserProfile: 'MENÚ DE PERFIL DE USUARIO',
    }
}